// Third Party Plugins
import React from 'react';

// Types
import { ContentBlockProps } from './types';

// Styles
import { StyledContent, StyledContentBlock } from './styles';

// Custom Components
import ImageContainer from '@/components/images/ImageContainer';
import BaseButton from '@/components/buttons/BaseButton';

const ContentBlock = ({
  heading,
  imageProps = {},
  showImage = false,
  callToActionLink,
  callToActionTitle,
  callToActionType = 'internal', // ✅ safer default
  showCallToAction = false,
  disableCallToAction = false,
  children,
}: ContentBlockProps) => {
  const shouldRenderCTA =
    !!callToActionLink && !!callToActionTitle && showCallToAction;

  return (
    <StyledContentBlock>
      {heading ? <h2>{heading}</h2> : null}

      {imageProps?.image && showImage ? (
        <ImageContainer
          {...imageProps}
          alt={imageProps.alt || 'Default Alt Text'}
        />
      ) : null}

      <StyledContent>{children}</StyledContent>

      {shouldRenderCTA && (
        <BaseButton
          className="c2a"
          actionType={callToActionType} // ✅ link-only types
          theme="solid"
          link={callToActionLink!} // safe due to guard above
          disabled={disableCallToAction}
        >
          {callToActionTitle}
        </BaseButton>
      )}
    </StyledContentBlock>
  );
};

export default ContentBlock;
